(() => {
  function updateCardImage(card, swatch) {
    const mediaDiv = card.querySelector('.card__media .media');
    if (!mediaDiv) return;

    const newSrc = swatch.dataset.imageUrl;
    if (!newSrc) return;

    const newAlt = swatch.dataset.imageAlt || '';

    // Update every img in the media container.
    // Dawn's media--hover-effect hides img[0] and shows img[1] on card hover,
    // so we must update both to keep the correct colour visible in all states.
    mediaDiv.querySelectorAll('img').forEach((img) => {
      img.removeAttribute('srcset'); // srcset overrides src — remove it first
      img.src = newSrc;
      if (newAlt) img.alt = newAlt;
    });

    card.querySelectorAll('.card-swatch').forEach((s) => s.classList.remove('is-active'));
    swatch.classList.add('is-active');
  }

  // Click: block anchor navigation, then swap image
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.card-swatch');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const card = swatch.closest('.card-wrapper');
    if (card) updateCardImage(card, swatch);
  }, false);

  // Hover: swap image on mouseenter (desktop)
  document.addEventListener('mouseover', (e) => {
    const swatch = e.target.closest('.card-swatch');
    if (!swatch) return;
    const card = swatch.closest('.card-wrapper');
    if (card) updateCardImage(card, swatch);
  });
})();
